<template>
  <div id="propertyTypes">
    <multiselect
      ref="multiselect"
      v-model="propertyTypesValue"
      :options="propertyTypesOptions"
      :class="{ 'border-bottom-blue': isPropertyTypeSet && !isPropertyTypeOpened }"
      placeholder="un appartement"
      :searchable="false"
      :multiple="true"
      :close-on-select="true"
      :internal-search="false"
      :clear-on-select="false"
      :allow-empty="false"
      :show-labels="false"
      track-by="id"
      label="label"
      selectLabel=""
      selectedLabel=""
      deselectLabel=""
      @close="setIsPropertyTypeOpened(false)"
      @open="setIsPropertyTypeOpened(true)"
    >
      <span
        class="caret"
        slot-scope="{ toggle }"
        :class="{ 'border-blue': isPropertyTypeSet }"
        @mousedown.prevent.stop="toggle"
        slot="caret"
      ></span
      ><span
        @click="closeMultiselect()"
        v-if="isPropertyTypeSet"
        class="text-center py-1 border-top bg-blue d-block"
        slot="afterList"
        ><IconSubmit class="icon-sm white"/></span
    ></multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapMutations, mapGetters, mapState } from "vuex";
import IconSubmit from "@/components/icons/IconSubmit.vue";

export default {
  components: {
    Multiselect,
    IconSubmit,
  },
  data() {
    return {
      isOpen: false,
      propertyTypesOptions: [
        { label: "un appartement", id: 0 },
        { label: "une maison", id: 1 },
      ],
    };
  },
  computed: {
    propertyTypesValue: {
      get() {
        /*** ARRAY OF VALUES TO ARRAY OF OBJECTS ***/
        let values = this.$store.state.userSearch.propertyTypes;
        return this.propertyTypesOptions.filter(objs => values.includes(objs.id));
      },
      set(objArray) {
        /*** ARRAY OF OBJECTS TO ARRAY OF VALUES ***/
        let values = objArray.map(obj => obj.id);
        this.$store.commit("SET_PROPERTY_TYPE", values);
      },
    },
    ...mapGetters(["isPropertyTypeSet"]),
    ...mapState(["isPropertyTypeOpened"]),
  },
  methods: {
    ...mapMutations({ setIsPropertyTypeOpened: "SET_IS_PROPERTY_TYPE_OPENED" }),
    focus() {
      this.$refs.multiselect.$el.focus();
    },
    closeMultiselect() {
      this.$refs.multiselect.deactivate();
    },
  },
  mounted() {
    if (this.$router.currentRoute.name != "dashboard") this.focus();
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/multiselect.scss";
@import "@/styles/transitions.scss";
.multiselect {
  @include media-breakpoint-up(md) {
    width: 17rem;
  }
}
</style>
